import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import style from './AnimatedPanel.scss';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
var AnimatedPanel = /** @class */ (function (_super) {
    __extends(AnimatedPanel, _super);
    function AnimatedPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.childFactoryMethod = function (child) {
            var _a = _this.props, activeChildIndex = _a.activeChildIndex, transitionClasses = _a.transitionClasses, timeout = _a.timeout;
            var previousActiveChildIndex = _this.state.previousActiveChildIndex;
            var currentTransitionClasses;
            if (isTransitionClasses(transitionClasses)) {
                var isGoingForward = activeChildIndex > previousActiveChildIndex;
                currentTransitionClasses = isGoingForward
                    ? transitionClasses.next
                    : transitionClasses.previous;
            }
            else {
                currentTransitionClasses = transitionClasses;
            }
            var transitionProps = {
                classNames: {
                    enter: currentTransitionClasses.enter,
                    enterActive: currentTransitionClasses.enterActive,
                    exit: currentTransitionClasses.exit,
                    exitActive: currentTransitionClasses.exitActive,
                },
                timeout: timeout,
            };
            return React.cloneElement(child, transitionProps);
        };
        // prevent clicks during animation process, original bug: PREM-10248
        _this.onRootClickHandler = function (e) {
            if (_this.state.isAnimationInProgress &&
                _this.props.preventClicksDuringAnimation) {
                e.stopPropagation();
            }
        };
        _this.state = {
            previousActiveChildIndex: _this.props.activeChildIndex,
            isAnimationInProgress: false,
        };
        return _this;
    }
    AnimatedPanel.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.props.activeChildIndex !== nextProps.activeChildIndex) {
            this.setState({ previousActiveChildIndex: this.props.activeChildIndex });
        }
    };
    AnimatedPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, activeChildIndex = _a.activeChildIndex, transitionClasses = _a.transitionClasses, timeout = _a.timeout, transitonGroupProps = __rest(_a, ["children", "activeChildIndex", "transitionClasses", "timeout"]);
        return (React.createElement(TransitionGroup, __assign({}, transitonGroupProps, { className: style.root, onClickCapture: this.onRootClickHandler, childFactory: this.childFactoryMethod }), React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                return (React.createElement(CSSTransition, { key: activeChildIndex, timeout: 0, classNames: "", onEnter: function () { return _this.setState({ isAnimationInProgress: true }); }, onExited: function () {
                        return _this.setState({ isAnimationInProgress: false });
                    } }, child));
            }
            return child;
        })[activeChildIndex]));
    };
    return AnimatedPanel;
}(React.Component));
export { AnimatedPanel };
function isTransitionClasses(obj) {
    return !!obj.next && !!obj.previous;
}
//# sourceMappingURL=AnimatedPanel.js.map